export default ({ mandatory = false, customError = null, optional }) => ({
  presence: mandatory && { message: customError },
  numericality: {
    ...optional
  }
});
